// Client Onboarding Hook — Stubbed (backing tables removed)

import type { OnboardingProgress, GoLiveSnapshot } from '@/lib/onboarding/types';

export function useClientOnboarding(_clientId?: string) {
  return {
    progress: null as OnboardingProgress | null,
    isLoading: false,
    error: null as Error | null,
    snapshots: [] as GoLiveSnapshot[],
    initializeOnboarding: (_id: string) => {
      console.warn('client_onboarding_progress table has been removed');
    },
    updateProgress: (_updates: Partial<OnboardingProgress>) => {
      console.warn('client_onboarding_progress table has been removed');
    },
    completeStep: (_args: { step: number; stepData?: Partial<OnboardingProgress> }, _opts?: unknown) => {
      console.warn('client_onboarding_progress table has been removed');
    },
    activateClient: (_notes?: string, _opts?: unknown) => {
      console.warn('client_go_live_snapshots table has been removed');
    },
    isInitializing: false,
    isUpdating: false,
    isCompleting: false,
    isActivating: false,
  };
}
